import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('cookieConfig');
export const actions = helper.createActions('cookieConfig', actionTypes);